import React from 'react'
import PropTypes from 'prop-types'
import styled from 'styled-components'

const NotImplemented = props =>
  <Wrapper env={ process.env.NODE_ENV }>NotImplemented { props['@type'] }</Wrapper>

NotImplemented.propTypes = {
  '@type': PropTypes.string
}

NotImplemented.type = 'default'

const Wrapper = styled.div`
  width: 95%;
  margin: 5px;
  padding: 5px;
  border: 1px solid grey;
  opacity: ${props => props.env === 'production' ? 0 : 1};
`

export default NotImplemented
